<tpm-card rounded-0 class="inner-news-card">
  <div class="inner-news-card-container">
    <tpm-tag *ngIf="!!props.sign" class="sign" textColor="#396E01" backgroundColor="#EEF9E5">{{ props.sign }}</tpm-tag>
    <div class="inner-news-card__body">
      <p>{{ props.teaser }}</p>
      <ng-container *ngIf="props.actions?.length">
        <a
          *ngFor="let action of props.actions; trackBy: trackByIndex"
          class="action-link"
          (click)="
            clicked.emit({
              action: action.action,
              url: action.url,
              entry: props
            });
            $event.stopPropagation()
          "
        >
          {{ action.label }}
          <tpm-icon icon="ec_controls_collapsed_dropdown"></tpm-icon>
        </a>
      </ng-container>
    </div>
  </div>
</tpm-card>
